import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">THE CONCEPTS DEFINED</span>
                                            </div>
                                            <p>These descriptions of its four elements will help to explain
                                                ‘personal meaning’:</p>
                                            <div className="border_subtitle">Self-Concept<a
                                                className="superscripttext boldlink"
                                                href="further_info.php?course=300"><sup>2</sup></a> – A person’s
                                                knowledge and understanding of his or her self
                                            </div>

                                            <p>Who we believe we are and how we would describe ourselves is our
                                                ‘self-concept’. It’s what makes us decide where we ‘fit’
                                                amongst, and compared to, others and provides us with consistent
                                                physical, psychological and social attributes. These could
                                                include all kinds of characteristics from being of sound mind to
                                                having particular beliefs. It provides an overall consistency of
                                                personality and behaviour as we tend to behave in ways in
                                                keeping with our self-concept. Many of our successes and
                                                failures are closely related to the ways in which we’ve learned
                                                to view ourselves and our relationships with others.</p>
                                            <div className="border_subtitle">Identity<a
                                                className="superscripttext boldlink"
                                                href="further_info.php?course=300"><sup>2</sup></a> – The
                                                distinct personality of an individual
                                            </div>

                                            <p>It’s the individual characteristics, deriving from our
                                                personalities, by which we’re recognised or known. They can
                                                include things such as family continuity and other affiliations
                                                or associations with others, or a recognisable separateness from
                                                others.</p>

                                            <div className="border_subtitle">Values<a
                                                className="superscripttext boldlink"
                                                href="further_info.php?course=300"><sup>3</sup></a> – Personal
                                                ethics or beliefs in which we have an emotional investment
                                            </div>
                                            <p>Our values influence the choices we make; they’re subjective and
                                                vary across people and cultures,
                                                resulting from circumstances, experiences and observations – and
                                                can change over time. For
                                                example, our choice of a new car may be influenced by values to
                                                which we subscribe, including
                                                status, price and family situation.</p>
                                            <div className="border_subtitle">Preferences<a
                                                className="superscripttext boldlink"
                                                href="further_info.php?course=300"><sup>3</sup></a> – This is
                                                what may influence your choices, motivations and behaviour
                                            </div>

                                            <p>For example, if you prefer dealing with figures to reading or
                                                writing, you may look for a job in finance rather than
                                                publishing.</p>
                                            <p>These concepts guide us every day but it’s our values and
                                                preferences which decide our behaviour and actions. They’re what
                                                we’ll focus on now, to try to answer this question:</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad lightbgshrink  greennumberroundbg1 lightbgcontentShrink uiheading job_background">
                                                <p>‘Why do I do this job?’</p></div>
                                            <br/>

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">‘WHY DO I DO THIS JOB?’</span>
                                            </div>
                                            <div className="border_subtitle">Step 1 – Record your values
                                            </div>
                                            <div className="paraspace"><p>Use the following table to capture
                                                your core values – those which matter to you most. These
                                                could include traditional, core values such as a sense of
                                                fairness, hard work and respect for others, or whatever you
                                                choose. To help you decide, ask yourself the following
                                                questions:</p></div>
                                            <ul className="greenbullet-list">

                                                <li>What are your most important beliefs?</li>
                                                <li>What is really important for you?</li>
                                                <li>Which principles guide your day-to-day behaviour?</li>
                                                <li className="list-bottom-pad">What issues would you fight
                                                    most strongly for?
                                                </li>


                                            </ul>

                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page2')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}